import React from "react";

import { useTranslation } from "react-i18next";
import { colors } from "global/globalStyle";

import { BarStrongLevelProps } from "./interface";
import { Bar, BarWrapper, TextBar } from "./styles";

const getColorByLevel = (
  strongLevel: "weak" | "medium" | "strong" | "gray",
): string => {
  switch (strongLevel) {
    case "weak":
      return colors.status_red;
    case "medium":
      return colors.status_yallow;
    case "strong":
      return colors.status_green;
    default:
      return colors.background_light;
  }
};

export const StrongBar: React.FC<BarStrongLevelProps> = ({ strongLevel }) => {
  const { t } = useTranslation();
  let bars: JSX.Element[] = [];

  switch (strongLevel) {
    case "weak":
      bars = [
        <Bar key={0} backgroundColor={getColorByLevel(strongLevel)} />,
        <Bar key={1} backgroundColor={getColorByLevel("gray")} />,
        <Bar key={2} backgroundColor={getColorByLevel("gray")} />,
      ];
      break;
    case "medium":
      bars = [
        <Bar key={0} backgroundColor={getColorByLevel(strongLevel)} />,
        <Bar key={1} backgroundColor={getColorByLevel(strongLevel)} />,
        <Bar key={2} backgroundColor={getColorByLevel("gray")} />,
      ];
      break;
    case "strong":
      bars = [
        <Bar key={0} backgroundColor={getColorByLevel(strongLevel)} />,
        <Bar key={1} backgroundColor={getColorByLevel(strongLevel)} />,
        <Bar key={2} backgroundColor={getColorByLevel(strongLevel)} />,
      ];
      break;
    default:
      break;
  }

  return (
    <BarWrapper>
      {bars}
      {strongLevel === "weak" ? (
        <TextBar strongLevel={strongLevel}>{t("passwordStrength.weak")}</TextBar>
      ) : null}
      {strongLevel === "medium" ? (
        <TextBar strongLevel={strongLevel}>{t("passwordStrength.medium")}</TextBar>
      ) : null}
      {strongLevel === "strong" ? (
        <TextBar strongLevel={strongLevel}>{t("passwordStrength.strong")}</TextBar>
      ) : null}
    </BarWrapper>
  );
};

export default StrongBar;
